const filterMethodCaseInsensitive = (filter, row) => {
  const { id, value: filterValue } = filter;

  let value = filterValue;
  let rowValue = row[id];

  if (
    rowValue &&
    typeof rowValue === 'object' &&
    rowValue.label !== undefined
  ) {
    const { label } = rowValue;
    rowValue = label;
  }

  if (
    value === null ||
    value === undefined ||
    value === '' ||
    (Array.isArray(value) && value.length === 0)
  ) {
    return true;
  }

  if (rowValue === null || rowValue === undefined) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.some((item) => {
      let currentValue = item;

      if (item && typeof item === 'object') {
        const { value: itemValue } = item;
        currentValue = itemValue;
      }

      return (
        String(rowValue).toLowerCase() === String(currentValue).toLowerCase()
      );
    });
  }

  if (
    typeof value === 'object' &&
    value !== null &&
    value.value !== undefined
  ) {
    const { value: selectedValue } = value;
    value = selectedValue;
  }

  if (typeof rowValue === 'boolean' || typeof value === 'boolean') {
    return String(rowValue) === String(value);
  }

  if (typeof rowValue === 'number') {
    rowValue = rowValue.toString();
  }

  if (typeof value === 'number') {
    value = value.toString();
  }

  if (typeof value === 'string' && !value.trim()) {
    return true;
  }

  return String(rowValue)
    .toLowerCase()
    .includes(String(value).trim().toLowerCase());
};

const filterMethodCommaSeparatedValues = (filter, row) => {
  const { id, value: filterValue } = filter;
  const rowValue = row[id];

  const filterTokens = String(filterValue)
    .split(',')
    .map((value) => value.trim())
    .filter((value) => value !== '');

  if (filterTokens.length === 0) return true;
  if (rowValue === null || rowValue === undefined) return false;

  const rowTokens = String(rowValue)
    .split(',')
    .map((value) => value.trim());

  return filterTokens.some((filterToken) => rowTokens.includes(filterToken));
};

const filterMethodExactValue = (filter, row) => {
  const filterValue =
    filter.value === null || filter.value === undefined
      ? ''
      : String(filter.value).trim();

  if (filterValue === '') return true;

  const rowValue = row[filter.id];

  if (rowValue === null || rowValue === undefined) return false;

  return String(rowValue) === filterValue;
};

export { filterMethodCaseInsensitive, filterMethodCommaSeparatedValues, filterMethodExactValue };
